import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"MobileMenu" */ './MobileMenu').then((mod) => mod.default));
